import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IParcelasReceber } from '@app/modules/contas-receber/models/parcelas.model';
import { Observable } from 'rxjs';
import {
  ConfigService,
  DeepPartial,
  EntityService
} from 'viggo-sistemas-core-web';
import { PaginationOptions } from 'viggo-sistemas-core-web/modules/core/model/entity-params';
import {
  EventoLimiteCredito,
  EventoLimiteCreditoResult,
  ICliente
} from '../models/cliente.model';

@Injectable()
export class ClienteService extends EntityService<ICliente> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'cliente',
        pluralBaseEntityEndPoint: 'clientes'
      }
    );
  }

  /**
   * Responsável por enviar um evento de atualização do limite de credito
   * @param cliente_id
   * @param evento
   * @returns
   */
  atualizarLimiteDeCredito(cliente_id: string, evento: EventoLimiteCredito) {
    const url = `${this.baseURL}/${cliente_id}/reg_cliente_limite_credito_evento`;
    return this.http.put<{ evento: EventoLimiteCreditoResult }>(url, evento, {
      headers: this.getHeader()
    });
  }

  /**
   * Pega todas as parcelas em aberto de um cliente
   * @param cliente_id
   * @param include
   * @param pagination
   * @param where
   * @param order_by
   * @returns
   */
  public pegarParcelasAbertas(
    cliente_id: string,
    include?: string[],
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    where?: DeepPartial<IParcelasReceber>,
    order_by?: string
  ): Observable<any> {
    const url = `${this.baseURL}/${cliente_id}/conta_receber_parcelas`;
    let params = new HttpParams();

    if (include) {
      params = params.append('include', include.join(','));
    }
    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (where) {
      params = params.append(`${Object.keys(where)[0]}`, where.status);
    }

    if (order_by) {
      params = params.append('order_by', order_by);
    }

    return this.http.get<{
      cliente: { conta_receber_parcelas: IParcelasReceber[] };
      pagination: PaginationOptions;
    }>(url, { headers: this.getHeader(), params });
  }
}
